import { Badge, Box, type BadgeProps } from '@chakra-ui/react';
import type { ReactNode } from 'react';

type CountBadgeProps = Omit<BadgeProps, 'children'> & {
  children: ReactNode;
};

// Wraps Chakra's Badge with the shape rules baked in so single-digit counts
// render as a circle and multi-digit counts expand to a pill.
export function CountBadge({ children, ...rest }: CountBadgeProps) {
  return (
    <Badge
      borderRadius="full"
      minW={5}
      h={5}
      px={1.5}
      fontSize="xs"
      lineHeight={1}
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      // Tabular figures render every digit in an identical cell, so the fixed
      // nudge below centres any count the same way.
      sx={{ fontVariantNumeric: 'tabular-nums' }}
      {...rest}
    >
      {/* The centred glyph lands half a pixel right of centre on the pixel grid;
          nudge it left to snap it dead-centre. */}
      <Box as="span" display="inline-block" transform="translateX(-0.5px)">
        {children}
      </Box>
    </Badge>
  );
}
